export default {
  getUserID: (state) => state.userId,
  getAuthCode: (state) => state.authCode,
  getEmail: (state) => state.email,
}
